export const TYPE_1 = {
  id: 'type_1',
  label: 'Sì, di 1° tipo',
};

export const TYPE_2 = {
  id: 'type_2',
  label: 'Sì, di 2° tipo',
};
export const TYPE_3 = {
  id: 'type_3',
  label: 'Sì, di 3° tipo',
};
export const TYPE_4 = {
  id: 'type_4',
  label: 'Sì, di 4° tipo',
};
export const NO = {
  id: 'no',
  label: 'No',
};
